import React, {useState, useEffect} from 'react'
import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import Stack from '@mui/material/Stack'
import {NavButton, RoundedButton} from '../../components/forms/inputs'
import useUser from '../../hooks/useUser'
import Path from '../../routeLinks'
import {setSubscription} from '../../services/alarms'
import type {Alarm as AlarmType} from '../../services/types'

type DialogProps = {
  alarm: AlarmType
  action: string
  onClose: () => void
  onConfirm: () => void
}
const SubscribeDialog = ({alarm, action, onClose, onConfirm}: DialogProps) => (
  <Dialog onClose={onClose} open>
    <Stack direction="column" sx={{p: 3}} justifyContent="space-around" spacing={4}>
      <DialogTitle>Are you sure you want to {action}?</DialogTitle>
      <Stack direction="row" justifyContent="space-around">
        <RoundedButton label="no" onClick={onClose} />
        <RoundedButton label="yes" onClick={onConfirm} />
      </Stack>
    </Stack>
  </Dialog>
)

const Subscribe = ({alarm, sx}: {alarm: AlarmType; sx?: {[k: string]: any}}) => {
  const [showDialog, setShowDialog] = useState(false)
  const [subscribed, setSubscribed] = useState<boolean>(alarm?.subscribed || false)
  const {user} = useUser()
  const label = subscribed ? 'Unsubscribe' : 'Subscribe'

  const toggleSubscription = async () => {
    setShowDialog(false)
    const res = await setSubscription(alarm.id, !subscribed)
    if (res === 'Alarm updated') setSubscribed(!subscribed)
  }

  useEffect(() => {
    const getter = async () => {
      setSubscribed(alarm?.subscribed || false)
    }
    getter()
  }, [alarm.subscribed])

  return (
    <>
      {showDialog && (
        <SubscribeDialog
          alarm={alarm}
          action={label.toLowerCase()}
          onClose={() => setShowDialog(false)}
          onConfirm={toggleSubscription}
        />
      )}
      {user ? (
        <RoundedButton label={label} onClick={() => setShowDialog(true)} sx={sx} />
      ) : (
        <NavButton label="Subscribe" sx={sx} to={Path.user.login(window.location.pathname)} />
      )}
    </>
  )
}

export default Subscribe
